import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9ab4dd30"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_4 = {
  key: 2,
  style: {
    "display": "flex"
  }
};
const _hoisted_5 = {
  key: 3,
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "15px"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("下一步");

const _hoisted_10 = {
  style: {
    "background-color": "white",
    "height": "300px"
  }
};
const _hoisted_11 = {
  style: {
    "text-overflow": "ellipsis",
    "overflow": "hidden",
    "white-space": "nowrap"
  }
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "50px"
  }
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("上一步");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("下一步");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_tree_select = _resolveComponent("el-tree-select");

  const _component_el_container = _resolveComponent("el-container");

  const _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, {
    style: {
      "width": "100%",
      "height": "100%"
    },
    "element-loading-text": '拼命加载中...' + $data.loadingTextArray.join(),
    "element-loading-spinner": "el-icon-loading",
    "element-loading-background": "rgba(0, 0, 0, 0.5)"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form, {
      model: $data.form,
      rules: $data.rules,
      ref: "form",
      "label-width": "100px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "产品购买渠道",
        style: {
          "margin": "20px 0"
        },
        prop: "radio"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.form.radio,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.radio = $event),
          id: "radio",
          style: {
            "margin-left": "50px",
            "display": "flex",
            "align-items": "center"
          },
          onChange: $options.radioChanged
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.purchasingChannelsDir, item => {
            return _openBlock(), _createBlock(_component_el_radio, {
              label: item.dictValue,
              style: {
                "height": "16px",
                "line-height": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.dictLabel), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 256))]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1
      }), $data.form.radio == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "订单编号",
        style: {},
        prop: "orderNum"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.orderNum,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.orderNum = $event),
          placeholder: "请选择",
          size: "default",
          onChange: $options.choseOrderNum
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orderNunList, (item, key, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: key,
              value: key,
              style: {
                "width": "250px"
              }
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "发货仓库",
        style: {},
        prop: "deliveryWarehouseName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.deliveryWarehouseName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.deliveryWarehouseName = $event),
          style: {
            "width": "227px"
          },
          disabled: "",
          placeholder: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })])) : _createCommentVNode("", true), $data.form.radio == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "付款时间",
        style: {},
        prop: "paymentTime"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.paymentTime,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.paymentTime = $event),
          style: {
            "width": "227px"
          },
          disabled: "",
          placeholder: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "质保情况",
        style: {
          "margin": "0 0 20px 15px"
        },
        prop: "warrantyTypeName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.warrantyTypeName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.warrantyTypeName = $event),
          placeholder: "请选择",
          size: "default"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warrantyTypeDir, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.dictValue,
              label: item.dictLabel,
              value: item.dictValue,
              onClick: $event => $options.warrChange(item.dictLabel)
            }, null, 8, ["label", "value", "onClick"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })])) : _createCommentVNode("", true), $data.form.radio === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "产品",
        style: {},
        prop: "productionId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.productionId,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.productionId = $event),
          placeholder: "请选择",
          size: "default",
          filterable: "",
          style: {
            "width": "619px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productList1, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.producitionName,
              value: item.producitionId,
              onClick: $event => $options.proChange(item.producitionName, item.producitionId)
            }, null, 8, ["label", "value", "onClick"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })])) : _createCommentVNode("", true), $data.form.radio === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "产品",
        style: {},
        prop: "productionId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.productionId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.productionId = $event),
          placeholder: "请选择",
          size: "default",
          filterable: "",
          style: {
            "width": "619px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productList2, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id,
              onClick: $event => $options.proChange(item.name, item.id)
            }, null, 8, ["label", "value", "onClick"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form_item, {
        "label-width": "135px",
        label: "商品品名",
        style: {},
        prop: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.tradeId,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.tradeId = $event),
          placeholder: "请选择商品品名",
          size: "default",
          filterable: "",
          style: {
            "width": "619px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tradeList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item,
              value: item
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })])]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "background-color": "rgba(255, 245,245)",
        "border": "1px solid rgba(210,0,47)",
        "color": "rgba(210,0,47)"
      },
      onClick: $options.cancel
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      style: {
        "width": "100px",
        "margin-left": "40px",
        "background-color": "rgba(210,0,47)",
        "color": "white",
        "border": "none"
      },
      onClick: $options.nextStep
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }, 8, ["onClick"])])], 512), [[_vShow, $data.step === 1]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
      model: $data.form2,
      ref: "form2",
      rules: $data.rules
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "SOP",
        "label-width": "135px",
        style: {
          "margin": "40px 0 25px 0"
        },
        prop: "sop"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tree_select, {
          modelValue: $data.form2.sop,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form2.sop = $event),
          data: $data.sopTreeList,
          filterable: "",
          "check-strictly": "",
          style: {
            "width": "619px"
          },
          "default-expand-all": "",
          props: $data.defaultProps,
          placeholder: "请选择/输入SOP名称",
          onChange: $options.sopTreeChange
        }, {
          default: _withCtx(({
            node
          }) => [_createVNode(_component_el_tooltip, {
            class: "item",
            effect: "dark",
            content: node.label,
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(node.label.replace(/\t/g, '')), 1)]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }, 8, ["modelValue", "data", "props", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "报损单",
        "label-width": "135px",
        prop: "damageReoprt"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form2.damageReoprt,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form2.damageReoprt = $event),
          placeholder: "请选择报损单",
          style: {
            "width": "619px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.templateList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.tempName,
              value: item.id,
              style: {
                "overflow": "hidden",
                "text-overflow": "ellipsis",
                "white-space": "nowrap",
                "width": "619px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                content: item.tempName,
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.tempName), 1)]),
                _: 2
              }, 1032, ["content"])]),
              _: 2
            }, 1032, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "问题现象",
        "label-width": "135px",
        prop: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          value: $options.getProblemPhenomenon($data.form2.damageReoprt),
          placeholder: "",
          style: {
            "width": "619px"
          },
          type: "textarea",
          resize: "none",
          disabled: ""
        }, null, 8, ["value"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "background-color": "rgba(255, 245,245)",
        "border": "1px solid rgba(210,0,47)",
        "color": "rgba(210,0,47)"
      },
      onClick: $options.cancel
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "margin-left": "30px",
        "background-color": "rgba(255, 245,245)",
        "border": "1px solid rgba(210,0,47)",
        "color": "rgba(210,0,47)"
      },
      onClick: $options.preStep
    }, {
      default: _withCtx(() => [_hoisted_14]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      style: {
        "width": "100px",
        "margin-left": "30px",
        "background-color": "rgba(210,0,47)",
        "color": "white",
        "border": "none"
      },
      onClick: $options.nextStep
    }, {
      default: _withCtx(() => [_hoisted_15]),
      _: 1
    }, 8, ["onClick"])])])], 512), [[_vShow, $data.step === 2]])])]),
    _: 1
  }, 8, ["element-loading-text"])), [[_directive_loading, $data.refresh]]);
}